module.exports = __webpack_public_path__ + "static/img/home-48.ac78c69c.png";